import { getUrlParameter } from 'router/navigation';
import { CONTENT_SECTION } from './constants';

export const getCurrentContentSection = () => {
  const currentSectionAsParam = getUrlParameter('contentSection');

  if (currentSectionAsParam) {
    return currentSectionAsParam;
  }

  const url = location.pathname ?? '';
  return url?.split('/')[2] ?? '';
};

export const getHippoContentSection = (param?: string) =>
  param !== 'employee-assistance' ? CONTENT_SECTION.hwr : CONTENT_SECTION.eap;
